/**
 * What the product does, in the depth an engineer evaluating it needs.
 *
 * These seven bands were the middle of the old single page. They did not need
 * rewriting — every claim in them is backed by a PASS row in
 * `docs/ACCEPTANCE_MATRIX.md` and carries the command that proves it, and that
 * vetting is the most expensive thing on this site. What they needed was a
 * reader who arrived on purpose: on a one-page site they sat behind a hero that
 * a decision-maker bounced off, and the person who *wanted* this detail had to
 * scroll past the pitch to reach it.
 *
 * Security and installation are deliberately not here. They are the other
 * question — not "what does it do" but "what happens when it goes wrong, and
 * what do I have to trust" — and a reader who has that question has it whether
 * or not they have read this page.
 */
import {
  Pools,
  Decision,
  Execution,
  Evidence,
  Approval,
  Continuity,
  Fleet,
} from '../sections/Sections'
import { PageHeader } from '../sections/PageHeader'
import { Closing } from '../sections/Closing'

export function ProductPage() {
  return (
    <>
      <PageHeader
        eyebrow="product.eyebrow"
        title="product.title"
        sub="product.sub"
        toc={['pools', 'decision', 'execution', 'evidence', 'approval', 'continuity', 'fleet']}
      />
      {/* The numbers are the page's index, repeated on the bands themselves, so
          a reader who is four bands deep knows there are three left. They are
          written here rather than counted in a loop because the order is the
          argument — pool, decision, execution, evidence — and a `map` over an
          array would make that order look incidental. */}
      <Pools index={1} />
      <Decision index={2} />
      <Execution index={3} />
      <Evidence index={4} />
      <Approval index={5} />
      <Continuity index={6} />
      <Fleet index={7} />
      <Closing />
    </>
  )
}
